export class UserLoginRequest {
    public user_id : string = '';
    public password : string = '';
    public user_token : string = '';
    public login_device_id : string = '';
    public readonly app_type : string = 'Admin';
    language_preference: number = 0;
}
